import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-description" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = {
  ref: "formRef",
  class: "form"
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "error-text small-text"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 1,
  class: "error-text small-text"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "submit-button" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "submit default-text-buttons" }, "Send")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "form-wrapper",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("contact-component.send-email")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "email-input default-text-contacts-grey-90",
          type: "text",
          ref: "email-field-ref",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          name: "email",
          placeholder: _ctx.emailPlaceholder,
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClick('email')))
        }, null, 40, _hoisted_5), [
          [_vModelText, _ctx.email]
        ]),
        (_ctx.validateEmail)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.errorEmail), 1))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("textarea", {
          class: "text-input default-text-contacts-grey-90",
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.text) = $event)),
          name: "message",
          ref: "text-area-ref",
          placeholder: _ctx.textPlaceholder,
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClick('textArea')))
        }, null, 40, _hoisted_7), [
          [_vModelText, _ctx.text]
        ]),
        (_ctx.validateTextArea)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.errorTextArea), 1))
          : _createCommentVNode("", true),
        _hoisted_9
      ], 512)
    ])
  ], 32))
}